module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "frontmatter",
      "id": "ser"
    }
  }, [_c('p', {
    staticClass: "sert"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page ii. ",
      "epub:type": "pagebreak",
      "id": "pii",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CHICAGO")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("FOUCAULT")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("PROJECT")])]), _vm._v(" "), _c('p', {
    staticClass: "sered"
  }, [_vm._v("Arnold I. Davidson, Henri-Paul Fruchaud, and Daniele Lorenzini, series editors")]), _vm._v(" "), _c('p', {
    staticClass: "serpf"
  }, [_vm._v("The wide-ranging and groundbreaking works of Michel Foucault (1926–84) have transformed our understanding of the human sciences and shaped contemporary thought in philosophy, history, critical theory, and more. In recent years, the publication of his lectures, seminars, and public discussions has made it possible not only to understand the trajectory of his work, but also to clarify his central ideas and to provide a better overall perspective on his thought. The aim of the Chicago Foucault Project is to contribute to this enterprise by publishing definitive English-language editions of these texts and fostering an ongoing appreciation of the lasting value of Foucault’s oeuvre in the English-speaking world.")]), _vm._v(" "), _c('p', {
    staticClass: "serf"
  }, [_c('i', [_vm._v("Madness, Language, Literature")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Edited by Henri-Paul Fruchaud, Daniele Lorenzini, and Judith Revel")]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Translated by Robert Bononno")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Speaking the Truth about Oneself: Lectures at Victoria University, Toronto, 1982")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Edited by Henri-Paul Fruchaud and Daniele Lorenzini")]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("English edition established by Daniel Louis Wyche")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("“Discourse and Truth” and “Parrēsia”")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Edited by Henri-Paul Fruchaud and Daniele Lorenzini")]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Introduction by Frédéric Gros")]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("English edition established by Nancy Luxon")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("About the Beginning of the Hermeneutics of the Self: Lectures at Dartmouth College, 1980")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Edited by Henri-Paul Fruchaud and Daniele Lorenzini")]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Introduction and critical apparatus by Laura Cremonesi, Arnold I. Davidson, Orazio Irrera, Daniele Lorenzini, and Martina Tazzioli")]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("Translated by Graham Burchell")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91648478","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-foucault-critique-0003.vue
// module id = 60
// module chunks = 0